import React,{useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { setInviter } from '../../request/Referrals/referalSlice';
import { useDispatch } from 'react-redux';

const Invitation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
      document.title = 'REFERRAL INITIALIZATION';
        let inviter = (new URLSearchParams(window.location.search)).get("referral");
        if (inviter !== '') {
            dispatch(setInviter(inviter));
            // localStorage.setItem('invited-by', inviter);
            setTimeout(() => {
                navigate('/register');
                // return window.location.href= 'https://eliteyield.com';
            }, 2000);
        }
    })
  return (
    <div></div>
  )
}

export default Invitation